import { Component, type ErrorInfo, type ReactNode } from 'react';
import { captureBrowserException } from '@minibook/shared/client/sentryBrowser';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    captureBrowserException(error, { componentStack: errorInfo.componentStack });
    if (import.meta.env.DEV) {
      console.error('[web-booking] ErrorBoundary:', error, errorInfo);
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div style={{ padding: 24, maxWidth: 480, margin: '40px auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, marginBottom: 12 }}>Что-то пошло не так</h1>
        <p style={{ marginBottom: 16, color: '#555' }}>
          Обновите страницу или попробуйте позже.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            border: '1px solid #ccc',
            background: '#fff',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Обновить
        </button>
      </div>
    );
  }
}
